import { Box, InputAdornment, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { SearchIcon } from "../../../../assets/icons/MUI/LayoutIcons";
import { useEffect, useState } from "react";

const SearchUsersOrGroups = ({
  searchType,
  onSearchChange,
}: {
  searchType: "FOLLOWERS" | "GROUPS";
  onSearchChange: (searchText: string) => void;
}) => {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState("");
  const [debouncedValue, setDebouncedValue] = useState("");

  useEffect(() => {
    // if (inputValue.length < 2) return;

    const handler = setTimeout(() => {
      setDebouncedValue(inputValue);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [inputValue]);

  useEffect(() => {
    onSearchChange(debouncedValue);
  }, [debouncedValue, onSearchChange]);

  return (
    <Box sx={{ display: "flex", marginBottom: "26px" }}>
      <TextField
        value={inputValue}
        onChange={(event) => setInputValue(event.target.value)}
        placeholder={
          searchType === "FOLLOWERS"
            ? t("pages.events.createEvent.searchByPlayerName")
            : t("pages.events.createEvent.searchByGroupName")
        }
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <SearchIcon style={{ fill: "none", width: "24px", height: "24px" }} />
            </InputAdornment>
          ),
        }}
        variant="outlined"
        sx={{
          alignSelf: "start",
          width: "400px",
          maxWidth: "100%",
          "& .MuiOutlinedInput-root": {
            padding: "0 20px",
          },
        }}
      />
    </Box>
  );
};

export default SearchUsersOrGroups;
